import React from 'react';
import { withSize } from 'react-sizeme';

function CalculateProductSize({ size, nrOfProducts, children }) {
  console.log(size.width);
  const maxPerRow = 5;

  const mediumMaxPerRow = 3;
  const smallMaxPerRow = 2;
  const XsmallMaxPerRow = 1;

  const numberOfProducts = nrOfProducts;

  let perRow = numberOfProducts;
  if (numberOfProducts > maxPerRow) {
    perRow = maxPerRow;
  }
  if (size.width < 700) {
    perRow = mediumMaxPerRow;
  }

  if (size.width < 500) {
    perRow = smallMaxPerRow;
  }

  if (size.width < 300) {
    perRow = XsmallMaxPerRow;
  }

  const testWidth = 100 / perRow;
  console.log(perRow);
  return (
    <div className="row is-flex">
      {React.Children.map(children, child =>
        React.cloneElement(child, { width: testWidth, existingProp: 'value' }))}
    </div>
  );
}

export default withSize()(CalculateProductSize);



// WEBPACK FOOTER //
// ./src/components/Resource/components/CalculateProductSize.js